import hoursToMilliseconds from 'date-fns/hoursToMilliseconds';

export const oneHourInMs = hoursToMilliseconds(1);
export const oneDayInMs = hoursToMilliseconds(24);
